export default "__VITE_ASSET__BIjkrNDi__"